// SdkView.tsx
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next'
import '../css/SdkView.css';
import { Link } from 'react-router-dom';
import { ROOT } from '../services/Api';

class SdkView extends React.Component<WithTranslation> {
    render() {
        const { i18n, lan } = this.props as any
        if (lan) {
            if (lan == 'zh_CN') {
                return this.renderCn()
            }
            else {
                return this.renderEn()
            }
        }
        else {
            const lang = i18n.language
            if (lang == 'zh_CN') {
                return this.renderCn()
            }
            else {
                return this.renderEn()
            }
        }
    }

    renderCn() {
        return (
            <div className="sdk-card">

                {/* Hero / SDK section */}
                <div className="sdk-hero">
                    <div className="sdk-hero-left">
                        <div className="sdk-badge">HeartMgmt SDK</div>
                        <h1 className="sdk-title">面向移动应用开发者的心电图解决方案</h1>
                        <p className="sdk-subtitle">
                            利用我们获得 <span className="sdk-highlight">CE 认证和 FDA 批准的 AI 算法</span>，安全地获取、处理和显示心电图结果
                        </p>
                        <p className="sdk-description">
                            我们的软件开发工具包（SDK）允许开发者在他们构建的应用中使用我们的心电图记录和 Kardia AI 技术。借助 HeartMgmt的 SDK，他们能够连接 设备名(DeviceName) 设备、启动心电图记录、显示波形、使用 HeartMgmt的 AI 算法解读结果，并将结果展示给用户。*
                        </p>
                        {/* Testimonial */}
                        <div className="sdk-testimonial">
                            <p className="sdk-quote">“得益于精心设计的 SDK、全面的技术文档、HeartMgmt敬业的工程支持团队，当然还有心电图设备本身，集成过程非常顺利。”</p>
                            <p className="sdk-author">John Smith</p>
                            <p className="sdk-author-title">Care Innovations<br />公司 运营高级总监</p>
                        </div>
                    </div>
                    <div className="sdk-hero-right">
                        {/* Placeholder for device image / illustration */}
                        <div className="sdk-device-placeholder">
                            <div className="sdk-device-icon">
                                <svg width="80" height="120" viewBox="0 0 80 120" fill="none">
                                    <rect x="10" y="10" width="60" height="100" rx="10" fill="#e0e7ff" stroke="#3b82f6" strokeWidth="3" />
                                    <rect x="25" y="25" width="30" height="40" rx="4" fill="#bfdbfe" />
                                    <rect x="30" y="30" width="20" height="30" rx="2" fill="#60a5fa" />
                                    <line x1="30" y1="70" x2="50" y2="70" stroke="#3b82f6" strokeWidth="2" />
                                    <line x1="30" y1="80" x2="45" y2="80" stroke="#3b82f6" strokeWidth="2" />
                                    <line x1="30" y1="90" x2="50" y2="90" stroke="#3b82f6" strokeWidth="2" />
                                    <circle cx="40" cy="105" r="6" fill="#3b82f6" />
                                </svg>
                            </div>
                            <div style={{ whiteSpace: 'nowrap' }}>
                                <Link to={`${ROOT}/sdkDev`} className="sdk-device-label" style={{ textDecoration: 'none' }}>
                                    注册
                                </Link>
                                <span> / </span>
                                <Link to={`${ROOT}/sdkDev`} className="sdk-device-label" style={{ textDecoration: 'none' }}>
                                    登录
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Features row */}
                <div className="sdk-features">
                    <div className="sdk-feature-item">
                        <span className="sdk-feature-icon">📁</span>
                        <span>在移动设备上创建可由您的移动应用管理的原始数据文件</span>
                    </div>
                    <div className="sdk-feature-item">
                        <span className="sdk-feature-icon">📊</span>
                        <span>可向用户显示心律条带视图，或创建记录内容的 PDF 文件</span>
                    </div>
                    <div className="sdk-feature-item">
                        <span className="sdk-feature-icon">🔒</span>
                        <span>保留原始数据文件和 PDF 的控制权，以便发送至您的系统</span>
                    </div>
                    <div className="sdk-feature-item">
                        <span className="sdk-feature-icon">📱</span>
                        <span>SDK 包适用于 Android 和 iOS 环境</span>
                    </div>
                </div>

                {/* Benefits section */}
                <div className="sdk-benefits">
                    <h2 className="sdk-benefits-title">对您组织的益处</h2>
                    <div className="sdk-benefits-grid">
                        <div className="sdk-benefit-card">
                            <div className="sdk-benefit-icon">⏱️</div>
                            <p>利用我们的即用型 SDK，最大程度减少移动应用开发时间和成本</p>
                        </div>
                        <div className="sdk-benefit-card">
                            <div className="sdk-benefit-icon">📤</div>
                            <p>将 设备名(DeviceName) 捕获的心电图数据以 PDF 或原始时间序列格式快速导入您的系统</p>
                        </div>
                        <div className="sdk-benefit-card">
                            <div className="sdk-benefit-icon">🤖</div>
                            <p>利用 HeartMgmtAI 算法自动将心电图分类为以下类别：正常窦性心律、可能房颤、心动过速或心动过缓</p>
                        </div>
                        <div className="sdk-benefit-card">
                            <div className="sdk-benefit-icon">✅</div>
                            <p>借助我们获得 CE 认证和 FDA 批准的即用型记录流程设备，简化或可能省去监管审批所需的时间</p>
                        </div>
                    </div>
                </div>

                {/* Footer note */}
                <div className="sdk-footer-note">
                    <p className="sdk-footer-text">* SDK 仅供开发者在构建应用时使用。临床使用需要单独的审批。</p>
                </div>
            </div>
        );
    }

    renderEn() {
        return (
            <div className="sdk-card">

                {/* Hero / SDK section */}
                <div className="sdk-hero">
                    <div className="sdk-hero-left">
                        <div className="sdk-badge">HeartMgmt SDK</div>
                        <h1 className="sdk-title">ECG solutions for mobile app developers</h1>
                        <p className="sdk-subtitle">
                            Leverage our CE-marked and <span className="sdk-highlight">FDA-cleared AI algorithms</span> to securely pull, process and display ECG results
                        </p>
                        <p className="sdk-description">
                            Our Software Development Kit (SDK) allows developers to use our ECG recording and Kardia AI technology inside the apps they build. With AliveCor's SDK, they have the ability to connect with the 设备名(DeviceName) device, initiate ECG recordings, display the waveform, interpret the results using AliveCor's AI algorithms and display the results to the user.*
                        </p>
                        {/* Testimonial */}
                        <div className="sdk-testimonial">
                            <p className="sdk-quote">“The integration process was extremely smooth, thanks to the combination of a well-architected SDK, comprehensive technical documentation, an engaged engineering support team at AliveCor, and of course the ECG devices themselves.”</p>
                            <p className="sdk-author">John Smith</p>
                            <p className="sdk-author-title">Care Innovations<br />Sr. Director, Company Operations</p>
                        </div>
                    </div>
                    <div className="sdk-hero-right">
                        {/* Placeholder for device image / illustration */}
                        <div className="sdk-device-placeholder">
                            <div className="sdk-device-icon">
                                <svg width="80" height="120" viewBox="0 0 80 120" fill="none">
                                    <rect x="10" y="10" width="60" height="100" rx="10" fill="#e0e7ff" stroke="#3b82f6" strokeWidth="3" />
                                    <rect x="25" y="25" width="30" height="40" rx="4" fill="#bfdbfe" />
                                    <rect x="30" y="30" width="20" height="30" rx="2" fill="#60a5fa" />
                                    <line x1="30" y1="70" x2="50" y2="70" stroke="#3b82f6" strokeWidth="2" />
                                    <line x1="30" y1="80" x2="45" y2="80" stroke="#3b82f6" strokeWidth="2" />
                                    <line x1="30" y1="90" x2="50" y2="90" stroke="#3b82f6" strokeWidth="2" />
                                    <circle cx="40" cy="105" r="6" fill="#3b82f6" />
                                </svg>
                            </div>
                            <div style={{ whiteSpace: 'nowrap' }}>
                                <Link to={`${ROOT}/sdkDev`} className="sdk-device-label" style={{ textDecoration: 'none' }}>
                                    Register
                                </Link>
                                <span> / </span>
                                <Link to={`${ROOT}/sdkDev`} className="sdk-device-label" style={{ textDecoration: 'none' }}>
                                    Login
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Features row */}
                <div className="sdk-features">
                    <div className="sdk-feature-item">
                        <span className="sdk-feature-icon">📁</span>
                        <span>Create a raw data file on the mobile device that your mobile app can manage</span>
                    </div>
                    <div className="sdk-feature-item">
                        <span className="sdk-feature-icon">📊</span>
                        <span>Options to display rhythm strip views to the user – or to create PDFs of the recording</span>
                    </div>
                    <div className="sdk-feature-item">
                        <span className="sdk-feature-icon">🔒</span>
                        <span>Retain control of raw data files and PDFs to send to your system</span>
                    </div>
                    <div className="sdk-feature-item">
                        <span className="sdk-feature-icon">📱</span>
                        <span>The SDK package is available for Android and iOS environments</span>
                    </div>
                </div>

                {/* Benefits section */}
                <div className="sdk-benefits">
                    <h2 className="sdk-benefits-title">BENEFITS TO YOUR ORGANIZATION</h2>
                    <div className="sdk-benefits-grid">
                        <div className="sdk-benefit-card">
                            <div className="sdk-benefit-icon">⏱️</div>
                            <p>Minimize mobile app development time and cost by utilizing our turnkey SDK</p>
                        </div>
                        <div className="sdk-benefit-card">
                            <div className="sdk-benefit-icon">📤</div>
                            <p>Quickly import into your system the ECG data captured by 设备名(DeviceName) in PDF or raw time series formats</p>
                        </div>
                        <div className="sdk-benefit-card">
                            <div className="sdk-benefit-icon">🤖</div>
                            <p>Leverage HeartMgmtAI algorithms for automatic classification of ECGs into the following categories: normal sinus rhythm, possible AF, tachycardia or bradycardia</p>
                        </div>
                        <div className="sdk-benefit-card">
                            <div className="sdk-benefit-icon">✅</div>
                            <p>Simplify or potentially eliminate time needed for regulatory clearance by leveraging our CE-marked and FDA-cleared device for turnkey recording flow</p>
                        </div>
                    </div>
                </div>

                {/* Footer note */}
                <div className="sdk-footer-note">
                    <p className="sdk-footer-text">* The SDK is intended for use by developers in building applications. Clinical use requires separate clearance.</p>
                </div>
            </div>
        );
    }
}

export const SdkPage = withTranslation()(SdkView);